import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const Footer = () => {
    const [footerText, setFooterText] = useState('');

    useEffect(() => {
        const fetchFooterText = async () => {
            const docRef = doc(db, "siteContent", "main");
            const docSnap = await getDoc(docRef);
            if (docSnap.exists() && docSnap.data().footerText) {
                setFooterText(docSnap.data().footerText);
            } else {
                // Texto padrão caso nada seja encontrado no banco de dados
                setFooterText(`© ${new Date().getFullYear()} Golden Blade Barbearia. Todos os direitos reservados.`);
            }
        };
        fetchFooterText();
    }, []);

    return (
        <footer className="bg-neutral-950 py-8">
            <div className="container mx-auto px-6 text-center text-gray-500 text-sm">
                <p>{footerText}</p>
                <p className="mt-2">Desenvolvido por: <a href="https://wa.link/eoolrt" className="text-gray-400 hover:text-primary transition-colors">Jonathan Crecencio</a>.</p>
            </div>
        </footer>
    );
};

export default Footer;
